import { useEffect, useState } from 'react';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

import useService from './useService';
import { PayInFilter } from './constants';

const usePayInDetails = () => {
	const { getPaymentStatus } = useService();
	const [payInData, setPayInData] = useState<any>({ data: [], rowCount: 0 });
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [filters, setFilters] = useState<PayInFilter | undefined>(undefined);
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const fetchPayInData = async () => {
		try {
			setShowLoader(true);
			const result = await getPaymentStatus(filters || {});
			setPayInData({ data: result?.data, rowCount: result?.rowCount });
			setForceUpdate(true);
		} catch (error: any) {
			setPayInData({ data: [], rowCount: 0 });
			setForceUpdate(true);
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (!isNil(filters)) {
			fetchPayInData();
		}
	}, [filters]);

	const getPayInData = () => {
		setForceUpdate(false);
		return payInData;
	};

	const handleFilterSubmit = (submittedFilters: PayInFilter) => {
		const { merchantName, orderId } = submittedFilters;

		if (!isEmpty(merchantName) && !isEmpty(orderId)) {
			setFilters({ merchantName, orderId });
		}
	};

	return { getPayInData, handleFilterSubmit, forceUpdate, showLoader };
};

export default usePayInDetails;
